import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-publication-not-published',
  templateUrl: './publication-not-published.component.html',
  styleUrls: ['./publication-not-published.component.scss']
})
export class PublicationNotPublishedComponent implements OnInit {
  constructor(private activeModal: NgbActiveModal) { }
  @Input() public message;

  ngOnInit() {
  }
  closeDialog() {
    this.activeModal.close();
  }
}
